import ServiceCard from "../Components/serviceCard";
import { bottom_services, sms } from "../Materials/images";
import servicesData from "../Materials/servicesList";

const topServicesData = servicesData.slice(0,2);// first 2 services.
const botomServicesData = servicesData.slice(2,7);// bottom 5 services.
function createServiceCard(service){
    // console.log(servicesData);
    return (
        <ServiceCard title={service.title} descriptions={service.description} image={service.image}/>
    );
}
function createBotomServiceCard(service) {
    return (
        <div className="botom-service-card">
            <h3>{service.title}</h3>
            <ul>
                {service.description.map((item) => {
                    return(<li>{item}</li>);
                })}
            </ul>
        </div>
    );
}
export default function ServicesPage(){
    return (
        <div className="services-container">

            <section className="hero">
                <div className= "hero-background"></div>
                <div className="hero-text hero-card">
                    <h1>Our Services</h1>
                </div>
            </section>
            <section className="services-text">
                <h4>Our services cover initial multi-disciplinary 
                    consultancy and design, procurement, execution, 
                    permitting, operation, and maintenance management 
                    of diverse rail systems across various 
                    technological domains—all seamlessly coordinated under 
                    a single umbrella to enhance efficiency, safety, and sustainability. 
                </h4>
            </section>
            <section className="services">
                <div className="sms-card">
                    <div className="sms-card-text">
                        <p>Our core competence is in delivering all-encompassing management 
                            of railway sidings, with a keen focus on Permitting and 
                            Compliance, as well as the oversight of siding maintenance. 
                            From the inception of a concept to its operational realization, 
                            our services span a comprehensive range, including the creation 
                            of dependable Safety Management Systems (SMS) and the management 
                            of railway siding maintenance.</p>

                        <p> As we develop bespoke siding management solutions, we maintain a close consultative relationship 
                            with our clients, focusing on SMS integration that embeds safety into 
                            everyday railway operations. Our SMS is designed to be all-inclusive,
                             addressing safety objectives, performance metrics, risk analysis, roles 
                             and responsibilities, governance, protocols, and continuous monitoring 
                             and assessment processes. This approach ensures adherence to the 
                             stipulations of the National Railway Safety Regulator 
                             Act (Act 16 of 2002, as amended).</p>
                    </div>
                    <div className="image-container">
                        <h3>Safety Management System (SMS) Approach: </h3>
                        <img src={sms} alt="Safety Management System" />
                    </div>
                    <p>
                        We extend our services to all railway operators in South Africa, 
                        including those from neighbouring countries whose rail operations 
                        intersect with South African territory.
                    </p>
                </div>
                {topServicesData.map(createServiceCard)}
                <div className="bottom-five-services">
                    <div className="img-container">
                        <img src={bottom_services} alt="5-bottom-services" />
                    </div>
                    <div className="botom-services-container">
                        {botomServicesData.map(createBotomServiceCard)}
                    </div>
                </div>
            </section>
    
        </div>
    );
}